import React, { useState } from "react";

const MAIN_MENU = [
  { key: "account", label: "Personal information", icon: "👤" },
  { key: "preferences", label: "Login & security", icon: "🛡️" },
  { key: "privacy", label: "Privacy", icon: "🔒" },
  { key: "notifications", label: "Notifications", icon: "🔔" },
  { key: "taxes", label: "Taxes", icon: "📄" },
  { key: "payments", label: "Payments", icon: "💳" },
  { key: "language", label: "Languages & currency", icon: "🌐" },
  { key: "travel", label: "Travel for work", icon: "💼" }
];

const SUB_MENUS = {
  account: [
    { key: "personal", label: "Personal information" },
    { key: "security", label: "Login & security" },
    { key: "privacy", label: "Privacy" },
    { key: "notifications", label: "Notifications" },
    { key: "taxes", label: "Taxes" },
    { key: "payments", label: "Payments" }
  ],
  preferences: [
    { key: "language", label: "Languages & currency" },
    { key: "travel", label: "Travel for work" }
  ]
};

export default function NotificationSetting() {
  const [mainMenu, setMainMenu] = useState("account");
  const [subMenu, setSubMenu] = useState("security");
  const [toggle1, setToggle1] = useState(true);
  const [toggle2, setToggle2] = useState(false);

  return (
    <div className="settings-layout">
      {/* MAIN MENU */}
      <aside className="main-menu">
        {MAIN_MENU.map(item => (
          <div
            key={item.key}
            className={`main-item ${mainMenu === item.key ? "active" : ""}`}
            onClick={() => {
              setMainMenu(item.key);
              setSubMenu(SUB_MENUS[item.key][0].key);
            }}
          >
            {item.label}
          </div>
        ))}
      </aside>

      {/* SUB MENU */}
      <aside className="sub-menu">
        {SUB_MENUS[mainMenu].map(item => (
          <div
            key={item.key}
            className={`sub-item ${subMenu === item.key ? "active" : ""}`}
            onClick={() => setSubMenu(item.key)}
          >
            {item.label}
          </div>
        ))}
      </aside>

      {/* CONTENT */}
      <main className="content-panel">
        <h3>Login & security</h3>

        <div className="info-box">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s.
        </div>

        <div className="ns-contentrow">
          <div>
            <p>Two-step verification</p>
            <span>
              Enhance the security of your account by requiring a second step of
              verification when you sign in.
            </span>
          </div>
          <label className="switch">
            <input
              type="checkbox"
              checked={toggle1}
              onChange={() => setToggle1(!toggle1)}
            />
            <span className="slider"></span>
          </label>
        </div>

        <div className="ns-contentrow">
          <div>
            <p>Security alerts</p>
            <span>
              Receive notifications about important changes to your account
              security.
            </span>
          </div>
          <label className="switch">
            <input
              type="checkbox"
              checked={toggle2}
              onChange={() => setToggle2(!toggle2)}
            />
            <span className="slider"></span>
          </label>
        </div>
      </main>
    </div>
  );
}
